/**
 * Instagram / Facebook uygulama içi tarayıcı yardımcısı.
 * Bu tarayıcılarda kart onayı (3D Secure) sık yarıda kaldığı için sepet çekmecesinde ve sepet sayfasında,
 * ödeme butonlarının üstünde bir şerit gösterilir:
 *  - Android: "Chrome'da öde" sepeti dolu haliyle Chrome'da açar.
 *  - iPhone: Safari zorla açılamaz; "••• → Tarayıcıda aç" adımı + sepet bağlantısını kopyala.
 *  - WhatsApp'tan sipariş: sepet içeriğiyle hazır mesaj (ödemede takılan müşteri kaybolmasın).
 * Sepet, adresteki ?pg_cart=varyant:adet,... ile taşınır: sayfa tarayıcıda açılınca sepet boşsa ürünler geri eklenir.
 * Sepete "Kaynak tarayıcı" notu yazılır; siparişlerden bu müşterilerin dönüşümü izlenebilir.
 */
const source = document.getElementById('PgInapp');
const root = window.Shopify?.routes?.root || '/';
const ua = navigator.userAgent || '';
const app = /Instagram/i.test(ua) ? 'Instagram' : /FBAN|FBAV|FB_IAB|FBIOS|FB4A/i.test(ua) ? 'Facebook' : null;
const ATTR = 'Kaynak tarayıcı';

const postJSON = (path, body) =>
  fetch(`${root}${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
const getCart = async () => (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();

/* ---------- Tarayıcıda açılan sayfa: taşınan sepeti geri kur ---------- */
const params = new URLSearchParams(location.search);
if (!app && params.has('pg_cart')) {
  const items = (params.get('pg_cart') || '')
    .split(',')
    .map((p) => p.split(':').map(Number))
    .filter(([id, q]) => id > 0 && q > 0)
    .map(([id, quantity]) => ({ id, quantity }));
  const from = params.get('pg_src');
  params.delete('pg_cart');
  params.delete('pg_src');
  const clean = `${location.pathname}${params.toString() ? `?${params}` : ''}${location.hash}`;
  (async () => {
    try {
      const cart = await getCart();
      if (cart.item_count === 0 && items.length) await postJSON('cart/add.js', { items });
      if (from) await postJSON('cart/update.js', { attributes: { [ATTR]: `${from} → tarayıcı` } });
    } catch (e) {
      /* sessiz: müşteri sepeti elle de kurabilir */
    }
    location.replace(clean);
  })();
}

/* ---------- Uygulama içi tarayıcı ---------- */
if (app && source) {
  const isAndroid = /Android/i.test(ua);
  const wa = (source.dataset.whatsapp || '').replace(/\D/g, '');
  let cart = null;

  // <html> sınıfı şeritten farklı olmalı: .pg-inapp stili (çerçeve, zemin, iç boşluk) tüm sayfaya uygulanıyordu
  document.documentElement.classList.add('pg-inapp-browser');
  const css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = source.dataset.css;
  document.head.appendChild(css);

  const money = (cents) => {
    try {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: cart?.currency || 'TRY' }).format(cents / 100);
    } catch (e) {
      return `${(cents / 100).toFixed(2)} ₺`;
    }
  };

  // İndirim aynı varyantı birden çok satıra bölebilir (ör. "2. üründe %20"); varyant başına tek satır
  const lines = () => {
    const byVariant = new Map();
    (cart?.items || []).forEach((i) => {
      const line = byVariant.get(i.variant_id) || { ...i, quantity: 0 };
      line.quantity += i.quantity;
      byVariant.set(i.variant_id, line);
    });
    return [...byVariant.values()];
  };

  const carryUrl = () => {
    const url = new URL(`${root}cart`, location.origin);
    const all = lines();
    if (all.length) {
      url.searchParams.set('pg_cart', all.map((i) => `${i.variant_id}:${i.quantity}`).join(','));
      url.searchParams.set('pg_src', app);
    }
    return url;
  };

  const waUrl = () => {
    const rows = lines().map((i) => {
      const variant = i.variant_title && i.variant_title !== 'Default Title' ? ` (${i.variant_title})` : '';
      return `• ${i.product_title}${variant} x ${i.quantity}`;
    });
    const text = ['Merhaba, sipariş vermek istiyorum:', ...rows, cart ? `Sepet toplamı: ${money(cart.total_price)}` : '']
      .filter(Boolean)
      .join('\n');
    return `https://wa.me/${wa}?text=${encodeURIComponent(text)}`;
  };

  const render = (box) => {
    const url = carryUrl();
    const open = box.querySelector('[data-pg-inapp-open]');
    if (open && isAndroid) {
      open.href = `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url)};end`;
    }
    const waLink = box.querySelector('[data-pg-inapp-wa]');
    if (waLink) waLink.href = waUrl();
  };

  const banner = () => {
    const box = document.createElement('div');
    box.className = 'pg-inapp';
    box.setAttribute('role', 'note');
    box.dataset.pgInapp = '';
    box.innerHTML = `
      <p class="pg-inapp__title">Ödemede sorun yaşamamak için</p>
      <p class="pg-inapp__text">${app} içinde kart onayı yarıda kalabiliyor. Sepetinizi tarayıcıda açıp güvenle ödeyin.</p>
      <div class="pg-inapp__actions">
        ${isAndroid
          ? `<a class="pg-inapp__btn pg-inapp__btn--primary" data-pg-inapp-open href="#">Chrome'da öde</a>`
          : `<button type="button" class="pg-inapp__btn pg-inapp__btn--primary" data-pg-inapp-copy>Sepet bağlantısını kopyala</button>`}
        ${wa ? `<a class="pg-inapp__btn" data-pg-inapp-wa href="#" target="_blank" rel="noopener">WhatsApp'tan sipariş</a>` : ''}
      </div>
      ${isAndroid ? '' : `<p class="pg-inapp__hint">Ya da sağ üstteki <b>•••</b> menüsünden <b>"Tarayıcıda aç"</b>ı seçin; sepetiniz Safari'de hazır olur.</p>`}`;
    render(box);
    return box;
  };

  const ensure = () => {
    const spots = [
      document.querySelector('#CartDrawer .hdt-mini-cart__bottom-wrap'),
      document.querySelector('#hdt-page-cart .hdt-main-cart__button-checkout')?.parentElement,
    ].filter(Boolean);
    spots.forEach((spot) => {
      if (!cart?.item_count) {
        spot.querySelector(':scope > [data-pg-inapp]')?.remove();
        return;
      }
      const existing = spot.querySelector(':scope > [data-pg-inapp]');
      if (existing) render(existing);
      else spot.prepend(banner());
    });
    // "••• → Tarayıcıda aç" mevcut adresi açar: adres sepeti taşısın
    if (cart?.item_count) {
      const url = new URL(location.href);
      const carry = carryUrl();
      url.searchParams.set('pg_cart', carry.searchParams.get('pg_cart'));
      url.searchParams.set('pg_src', app);
      if (url.href !== location.href) history.replaceState(history.state, '', url);
    }
  };

  let timer = null;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        cart = await getCart();
      } catch (e) {
        return;
      }
      if (cart.item_count && cart.attributes?.[ATTR] !== `${app} uygulaması`) {
        postJSON('cart/update.js', { attributes: { [ATTR]: `${app} uygulaması` } }).catch(() => {});
      }
      ensure();
    }, 300);
  };

  document.addEventListener('click', async (e) => {
    const copy = e.target.closest('[data-pg-inapp-copy]');
    if (!copy) return;
    const link = carryUrl().toString();
    try {
      await navigator.clipboard.writeText(link);
    } catch (err) {
      window.prompt('Bağlantıyı kopyalayın ve Safari\'de açın:', link);
      return;
    }
    copy.textContent = 'Kopyalandı — Safari\'ye yapıştırın';
  });

  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const p = origFetch.apply(this, args);
    if (/\/cart\/(add|change|clear)(\.js)?/.test(url)) p.then(refresh, () => {});
    return p;
  };
  // Çekmece / sepet sayfası yeniden çizilince şerit geri eklenir; kaydırıcı vb. sık DOM değişikliklerinde
  // her değişiklik yerine kare başına en fazla bir kontrol yapılır
  let queued = false;
  new MutationObserver(() => {
    if (!cart || queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      ensure();
    });
  }).observe(document.body, { childList: true, subtree: true });
  refresh();
}
